
















import { defineComponent, PropType } from "@vue/composition-api"
import { ISlide } from "../../models/slide"
import HeadingAtom from "@/shared/components/atoms/HeadingAtom.vue"
import IconLinkAtom from "@/shared/components/atoms/IconLinkAtom.vue"

declare global {
    interface Window {
        dataLayer: any[]
    }
}

export default defineComponent({
    name: "IntroComponent",
    components: {
        HeadingAtom,
        IconLinkAtom
    },
    props: {
        slide: {
            type: Object as PropType<ISlide>,
            required: true
        },
        showIntroText: {
            type: Boolean,
            default: false
        },
        showLink: {
            type: Boolean,
            required: true,
            default: false
        },
        iconLinkClass: {
            type: String,
            default: ""
        },
        enableTracking: {
            type: Boolean,
            default: false
        }
    },
    setup(props, { emit }) {
        const trackClick = () => {
            emit("click")

            if (!props.enableTracking) { return }

            const clickUrl = resolveUrl(props.slide.link || '');
            if (!clickUrl) { return }

            const clickText = props.slide.linkText || props.slide.title
            const title = props.slide.title

            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
                event: "slider_click",
                block_title: title,
                click_url: clickUrl,
                click_text: clickText
            })
        }

        const resolveUrl = (url: string): string => {
            if (!url) {
                return '';
            }
            return url.startsWith('http')
                ? url
                : `${window.location.origin}${url}`;
        };

        return { trackClick }
    }
})
